import { Drawer } from 'antd'
import { FC, memo, useState, useEffect } from 'react'
import styles from './index.module.scss'
import { useTranslation } from '@/services/i18n'
import { ReactComponent as CloseModalIcon } from '@/assets/icons/closeModal.svg'
import SelectReceiver from './SelectReceiver'
import ConfirmReceiver from './ConfirmReceiver'
import { useReceiverInfo } from '@/hooks/tx'
import { WalletCoin } from '@/services/apis/coin/models'
import Modal from '@/components/Modal'
import { CheckAddrDTO } from '@/services/apis/tx/models'
import WarnTitle from '@/assets/images/warnTitle.png'
interface SendDrawerProps {
  open: boolean
  onClose: () => void
  coinKey: string
  onSelectCoin: (val: string) => void
  coins: WalletCoin[]
}

const SendDrawer: FC<SendDrawerProps> = ({ open, onClose, coinKey, onSelectCoin, coins }) => {
  const { t } = useTranslation()
  const [step, setStep] = useState(0)
  const title = step === 1 ? t('common.send') : t('wallet.sendDrawer.title')
  const { receiverInfo, checkAndSetReceiver, isChecking, setReceiverInfo } = useReceiverInfo()

  useEffect(() => {
    // 关闭drawer后，重置所有状态
    if (!open) {
      setStep(0)
      setReceiverInfo(undefined)
    }
  }, [open, coinKey])
  const onNext = async (
    dto: Omit<CheckAddrDTO, 'coinKey'>,
    silence = false
  ): Promise<string | undefined> => {
    const { isValid, errMsg, isContract, isPhishing } = await checkAndSetReceiver({
      coinKey,
      ...dto,
    })

    if (errMsg) {
      if (silence) {
        return errMsg
      }
      window.shMessage.error(errMsg)
      return
    }

    const checkPhishing = () => {
      return new Promise<boolean>((resolve, reject) => {
        if (isPhishing) {
          Modal.confirm({
            title: t('record.fraudulentAddressTip'),
            content: t('record.fraudulentAddressContent'),
            okText: t('common.continue'),
            icon: <img src={WarnTitle} alt="" style={{ height: '46px', width: '46px' }}></img>,
            closable: true,
            onOk() {
              resolve(true)
            },
            onCancel() {
              resolve(false)
            },
            wrapClassName: styles.warningWarpper,
          })
          return
        } else {
          resolve(true)
        }
      })
    }
    const checkContract = () => {
      return new Promise<boolean>((resolve, reject) => {
        if (isContract) {
          Modal.confirm({
            title: t('wallet.sendDrawer.contractAddressTipTitle'),
            content: t('wallet.sendDrawer.contractAddressTipDesc'),
            onOk() {
              resolve(true)
            },
            onCancel() {
              resolve(false)
            },
          })
          return
        } else {
          resolve(true)
          return
        }
      })
    }

    const res1 = await checkPhishing()
    if (!res1) return
    const res2 = await checkContract()
    if (!res2) return
    setStep(1)

    if (isValid) {
      setStep(1)
    }
  }
  return (
    <Drawer
      title={title}
      placement="right"
      open={open}
      width={560}
      push={{ distance: 0 }}
      className={styles.drawer}
      closable={false}
      destroyOnClose={true}
      maskClosable={false}
      extra={
        <div onClick={onClose} className={styles.closeIcon}>
          <CloseModalIcon />
        </div>
      }
      footer={null}
    >
      {step === 0 && (
        <SelectReceiver
          onClose={onClose}
          onNext={onNext}
          coins={coins}
          coinKey={coinKey}
          onSelectCoin={onSelectCoin}
          isChecking={isChecking}
        />
      )}
      {step === 1 && receiverInfo && (
        <ConfirmReceiver onClose={onClose} receiver={receiverInfo} coinKey={coinKey} />
      )}
    </Drawer>
  )
}

export default memo(SendDrawer)
